import { Box, Grid } from '@material-ui/core';
import React, { useState } from 'react';
import {
    LevelContainer,
    LevelDropdownContainer,
    LevelTitle,
    StyledText,
    SubTitle,
} from './levelProcedure.styled';
import AddProcedureLevel from './AddProcedureLevel';
import { useTranslation } from 'react-i18next';
import useWindowSize from '../getWindowSize';
import { sizes } from 'src/styles/Media.styled';
import { useDispatch, useSelector } from 'react-redux';
import {
    addProcedureLevel,
    checkIsErrorFoundInFirstLevel,
    checkIsErrorFoundInProcedureLevel,
    setIsFirstLivSelected,
    setLivLevelArray,
    setModifiedLevelDataFlag,
    setProcedureLevel,
} from 'src/pages/reportUsage/redux/action/actionCreators';
import { setUivLevelArray } from 'src/pages/reportUsage/redux/action/actionCreators';
import { Title } from '../Procedure.styled';
import { BASE_TEXT_PX, FONT_FAMILY_ITALIC } from '../../../styles/fonts/MCFontConstants';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const LevelProcedureCard = ({
    levelProcdureTitle = 'Levels',
    levelsData,
    procedureInfoData,
    setProcedureInfoData,
}) => {
    const dispatch = useDispatch();

    const upsertLevelCodeAtIndex = (currentArray, index, value) => {
        const next = Array.isArray(currentArray) ? [...currentArray] : [];
        const safeIndex = Number.isFinite(index) ? index : 0;
        while (next.length <= safeIndex) {
            next.push(0);
        }
        next[safeIndex] = value ?? 0;
        return next;
    };

    const [currentId, setCurrentId] = useState(0);
    const [isFoundDuplicate, setIsFoundDuplicate] = React.useState(false);
    const [prevRow, setPrevRow] = React.useState(null);
    const [errorMsg, setErrorMsg] = React.useState('');
    // const [draftLevels, setDraftLevels] = useState(false);
    // const [errorFirstLevelMsg, setErrorFirstLevelMsg] = React.useState('');

    const uivDropdownValue = useSelector(
        (state) => state.reportUsageRootReducer.uivDropdownValue.uivState
    );
    const livDropdownValue = useSelector(
        (state) => state.reportUsageRootReducer.livDropdownValue.livState
    );
    const isFirstUivSelected = useSelector(
        (state) => state.reportUsageRootReducer.uivDropdownValue.isSelected
    );
    const isFirstLivSelected = useSelector(
        (state) => state.reportUsageRootReducer.livDropdownValue.isSelected
    );
    const { procedureLevels, isErrorFoundInProcedure } =
        useSelector((state) => state.reportUsageRootReducer);
    const levelsDataNew = useSelector(
        (state) => state.reportUsageRootReducer.procedureData.levelsData
    );
    // const currRowId = useSelector(
    //     (state) => state.reportUsageRootReducer.currRowId
    // );
    const isFirstLevelSelected = useSelector(
        (state) => state.reportUsageRootReducer.isFirstLevelSelected
    ); 
    const isErrorFoundInFirstLevel = useSelector(
        (state) => state.reportUsageRootReducer.isErrorFoundInFirstLevel
    );
    let numberOfLevels =
        procedureLevels?.length > 0 ? procedureLevels?.length : 0;
    // // )[0]?.uivDropdown.uivState?.code;
    // console.log('currUivCode', currUivCode);
    // let currLivCode = procedureLevels?.filter(
    //     (level) => level.id === currRowId
    // )[0]?.livDropdown.livState?.code;
    // console.log('currLivCode', currLivCode); 
    const addProcedureLevelHandler = () => {
        // setDraftLevels(true);
        const newId = numberOfLevels + 1;
        setCurrentId(newId);
        const newLevel = {
            id: newId,
            uivDropdown: {
                uivState: '',
                isSelected: null,
            },
            livDropdown: {
                livState: '',
                isSelected: null,
            },
            error: '',
            informationalMsg: '',
        };
        dispatch(addProcedureLevel(newLevel));
        setPrevRow(procedureLevels.slice(0, newId));
    };
 

    const uivArray = useSelector(
        (state) => state.reportUsageRootReducer.uivArray
    );
    const livArray = useSelector(
        (state) => state.reportUsageRootReducer.livArray
    );
    const uivFirstLevel = useSelector(
        (state) => state.reportUsageRootReducer.uivFirstLevel
    );
    const livFirstLevel = useSelector(
        (state) => state.reportUsageRootReducer.livFirstLevel
    );

    useEffectWithErrorLogging(() => {
        const arraysEqual = (a, b) => {
            if (a === b) return true;
            if (!Array.isArray(a) || !Array.isArray(b)) return false;
            if (a.length !== b.length) return false;
            for (let i = 0; i < a.length; i += 1) {
                if (a[i] !== b[i]) return false;
            }
            return true;
        };

        // Keep payload arrays derived from UI selections (dense, no 0-padding).
        const pairs = [];
        const firstUivCode = uivDropdownValue?.code;
        const firstLivCode = livDropdownValue?.code;
        if (firstUivCode && firstLivCode) {
            pairs.push([firstUivCode, firstLivCode]);
        }

        (Array.isArray(procedureLevels) ? procedureLevels : []).forEach(
            (level) => {
                const uivCode = level?.uivDropdown?.uivState?.code;
                const livCode = level?.livDropdown?.livState?.code;
                if (uivCode && livCode) {
                    pairs.push([uivCode, livCode]);
                }
            }
        );

        const nextUivArray = pairs.map((p) => p[0]);
        const nextLivArray = pairs.map((p) => p[1]);

        if (
            !arraysEqual(nextUivArray, uivArray) ||
            !arraysEqual(nextLivArray, livArray)
        ) {
            dispatch(setUivLevelArray(nextUivArray));
            dispatch(setLivLevelArray(nextLivArray));
        }
    }, [uivDropdownValue, livDropdownValue, procedureLevels, uivArray, livArray, dispatch]);

    useEffectWithErrorLogging(() => {
        const isErrorFound = procedureLevels?.some(
            (level) => level.error !== '' && level.error !== undefined
        );
        const isEmptyLevel = procedureLevels?.some(
            (level) =>
                level.uivDropdown.uivState?.length === 0 ||
                level.livDropdown.livState?.length === 0 ||
                (level.uivDropdown.uivState?.code &&
                    !level.livDropdown.livState?.code) ||
                (!level.uivDropdown.uivState?.code &&
                    level.livDropdown.livState?.code)
        ); 
        if (isErrorFound || isEmptyLevel) {
            dispatch(checkIsErrorFoundInProcedureLevel(true));
        } else {
            dispatch(checkIsErrorFoundInProcedureLevel(false));
        }
    }, [procedureLevels]);

    const handleDeleteItem = (id) => {
        const filteredLevels = procedureLevels?.filter(
            (level) => level.id !== id
        );
        const rearrangedLevels = filteredLevels.map((level, index) => ({
            ...level,
            id: index + 1,
        }));

        dispatch(setProcedureLevel(rearrangedLevels));
        setCurrentId(currentId - 1);
 

        const deletedArray = procedureLevels?.filter((item) => item.id === id);
        // const deletedUivCode = deletedArray[0]?.uivDropdown.uivState?.code;
        // const deletedLivCode = deletedArray[0]?.livDropdown.livState?.code; 
        if (deletedArray.length > 0) {
            // uivArray/livArray are derived from dropdown selections via effect above.
            // Avoid index-based filtering here because it can remove the wrong entry
            // when some rows are unfilled.
            if (isErrorFoundInProcedure) {
                dispatch(checkIsErrorFoundInProcedureLevel(true));
            } else {
                dispatch(checkIsErrorFoundInProcedureLevel(false));
            }
            // let modifiedLevelData = [];
            // modifiedLevelData = getModifiedLevelsSelectionAfterDelete(
            //     levelsData,
            //     errorMsg,
            //     deletedUivCode,
            //     deletedLivCode,
            //     procedureLevels
            // );
            // console.log('modifiedLevelData', modifiedLevelData);
            // dispatch(
            //     setProcedureData({
            //         ...procedureInfoData,
            //         levelsData: modifiedLevelData
            //     })
            // );
            // setProcedureInfoData((prevState) => ({
            //     ...prevState,
            //     levelsData: modifiedLevelData
            // }));
        }
    };

    const updateUivLevelState = (id, stateKey, newState) => {
        dispatch(
            setProcedureLevel(
                procedureLevels?.map((level) =>
                    level.id === id
                        ? {
                              ...level,
                              uivDropdown: {
                                  ...level.uivDropdown,
                                  [stateKey]: newState,
                              },
                          }
                        : level
                )
            )
        );
        setPrevRow(
            procedureLevels?.slice(0, procedureLevels.length - 2).map((level) =>
                level.id === procedureLevels.length - 2
                    ? {
                          ...level,
                          uivDropdown: {
                              ...level.uivDropdown,
                              [stateKey]: newState,
                          },
                      }
                    : level
            )
        );
    };

    const updateLivLevelState = (id, stateKey, newState) => {
        dispatch(
            setProcedureLevel(
                procedureLevels?.map((level) =>
                    level.id === id
                        ? {
                              ...level,
                              livDropdown: {
                                  ...level.livDropdown,
                                  [stateKey]: newState,
                              },
                          }
                        : level
                )
            )
        );
        setPrevRow(
            procedureLevels?.slice(0, procedureLevels.length - 2).map((level) =>
                level.id === procedureLevels.length - 2
                    ? {
                          ...level,
                          uivDropdown: {
                              ...level.uivDropdown,
                              [stateKey]: newState,
                          },
                      }
                    : level
            )
        );
    };

    const updateUivSelectedState = (id, stateKey, isSelectedState) => {
        dispatch(
            setProcedureLevel(
                procedureLevels?.map((level) =>
                    level.id === id
                        ? {
                              ...level,
                              informationalMsg:
                                  isSelectedState === false
                                      ? ''
                                      : level.informationalMsg,
                              error:
                                  isSelectedState === false ? '' : level.error,
                              uivDropdown:
                                  isSelectedState !== false
                                      ? {
                                            ...level.uivDropdown,
                                            [stateKey]: isSelectedState,
                                        }
                                      : [],
                          }
                        : level
                )
            )
        );
    };

    const updateLivSelectedState = (id, stateKey, isSelectedState) => {
        dispatch(
            setProcedureLevel(
                procedureLevels.map((level) =>
                    level.id === id
                        ? {
                              ...level,
                              informationalMsg:
                                  isSelectedState === false
                                      ? ''
                                      : level.informationalMsg,
                              error:
                                  isSelectedState === false ? '' : level.error,
                              livDropdown:
                                  isSelectedState !== false
                                      ? {
                                            ...level.livDropdown,
                                            [stateKey]: isSelectedState,
                                        }
                                      : [],
                          }
                        : level
                )
            )
        ); 
    };

    const updateErrorMessages = (procedureLevels) => {
        const codeMap = new Map();
        if (
            (!uivDropdownValue?.code && livDropdownValue?.code) ||
            (uivDropdownValue?.code && !livDropdownValue?.code)
            // (uivDropdownValue === (undefined || 0 || '')
            // && livDropdownValue?.code ) ||
            // (uivDropdownValue?.code && livDropdownValue === (undefined || 0 || '')   )
        ) {
            dispatch(checkIsErrorFoundInFirstLevel(true));
        } else if (uivDropdownValue?.code <= livDropdownValue?.code) {
            dispatch(checkIsErrorFoundInFirstLevel(false));
            dispatch(setIsFirstLivSelected(true));
        }
        return procedureLevels?.map((level, index) => {
            const uivCode = level?.uivDropdown?.uivState?.code;
            const livCode = level?.livDropdown?.livState?.code;
            const codeKey = `${uivCode}-${livCode}`;
            const codekey1 = `${uivDropdownValue?.code}-${livDropdownValue?.code}`;

            // Initialize error message
            let errorMessage = '';
            let informationaEachlMsg = '';
            if (uivCode > 0 && livCode > 0) {
                // Check for duplicate levels with the input combination
                if (
                    level.uivDropdown.uivState.code ===
                        uivDropdownValue?.code &&
                    level.livDropdown.livState.code === livDropdownValue?.code
                ) {
                    const firstOccurrenceIndex = codeMap.get(codekey1) + 1; 
                    if (firstOccurrenceIndex !== index) {
                        errorMessage = 'Same levels already entered above.';
                        setIsFoundDuplicate(true);
                        setErrorMsg(errorMessage);
                        // let modifiedErrorData = [];
                        // modifiedErrorData = getModifiedErrorLevelsSelection(
                        //     levelsData,
                        //     errorMessage
                        // );
                        // console.log('modifiedErrorData', modifiedErrorData);
                        // dispatch(
                        //     setProcedureData({
                        //         ...procedureInfoData,
                        //         levelsData: modifiedErrorData,
                        //         levels: modifiedErrorData
                        //     })
                        // );
                        // setProcedureInfoData((prevState) => ({
                        //     ...prevState,
                        //     levelsData: modifiedErrorData,
                        // }));
                    }
                } else if (
                    level.uivDropdown.uivState?.code !==
                        uivDropdownValue?.code ||
                    level.livDropdown.livState?.code !== livDropdownValue?.code
                ) {
                    const firstOccurrenceIndex = codeMap.get(codekey1) + 1; 
                    if (firstOccurrenceIndex !== index) {
                        errorMessage = '';
                    }
                } else if (
                    (!uivDropdownValue?.code && livDropdownValue?.code) ||
                    (uivDropdownValue?.code && !livDropdownValue?.code)
                    // (uivDropdownValue
                    //     ? Object.keys(uivDropdownValue).length === 0
                    //     : 0 && livDropdownValue?.code) ||
                    // (uivDropdownValue?.code && livDropdownValue
                    //     ? Object.keys(livDropdownValue).length === 0
                    //     : 0)
                ) {
                    errorMessage = '';
                    dispatch(checkIsErrorFoundInFirstLevel(true));
                } else {
                    codeMap.set(codekey1, index);
                }

                // Check for duplicate levels within procedureLevels
                if (codeMap.has(codeKey)) {
                    const firstOccurrenceIndex = codeMap.get(codeKey);
                    if (firstOccurrenceIndex !== index) {
                        setIsFoundDuplicate(true);
                        errorMessage = 'Same levels already entered above.';
                        setErrorMsg(errorMessage);
                        // let modifiedErrorData = [];
                        // modifiedErrorData = getModifiedErrorLevelsSelection(
                        //     levelsData,
                        //     errorMessage
                        // );
                        // console.log('modifiedErrorData', modifiedErrorData);
                        // dispatch(
                        //     setProcedureData({
                        //         ...procedureInfoData,
                        //         levelsData: modifiedErrorData,
                        //     })
                        // );
                        // setProcedureInfoData((prevState) => ({
                        //     ...prevState,
                        //     levelsData: modifiedErrorData,
                        // }));
                    }
                } else {
                    codeMap.set(codeKey, index);
                }

                // Add other error checks here if needed
                if (uivCode > livCode) {
                    errorMessage = 'UIV must be at or above LIV level';
                }
                if (uivCode === livCode) {
                    (level.error === 'UIV must be at or above LIV level' ||
                        level.error === '') &&
                        (informationaEachlMsg =
                            'No motion segment levels involved in procedure');
                }
            } else {
                dispatch(checkIsErrorFoundInProcedureLevel(true));
            }

            return {
                ...level,
                error: errorMessage,
                informationalMsg: informationaEachlMsg,
            };
        });
    };

    const updateEachErrorState = (value) => { 
        const updatedProcedureLevels = updateErrorMessages(procedureLevels); 
        dispatch(setProcedureLevel(updatedProcedureLevels));
        updatedProcedureLevels && dispatch(setModifiedLevelDataFlag(true));
        errorMsg !== '' && setErrorMsg('');
        // dispatch(
        //     setProcedureLevel(
        //         procedureLevels.map((level) =>
        //             level.id === id ? { ...level, error: value } : level
        //         )
        //     )
        // );
    };

    const updateEachUivCount = (id, value) => {
        const filteredLevels = procedureLevels.filter(
            (level) => level.id === id
        ); 
        const updatedUivArray = upsertLevelCodeAtIndex(uivArray, id, value);
        dispatch(setUivLevelArray(updatedUivArray));
    };

    const updateEachLivCount = (id, value) => {
        const filteredLevels = procedureLevels?.filter(
            (level) => level.id === id
        ); 
        const updatedLivArray = upsertLevelCodeAtIndex(livArray, id, value);
        dispatch(setLivLevelArray(updatedLivArray));
    };

    const getAppendProcedureLevel = () => {
        return procedureLevels?.map((level) => (
            <AddProcedureLevel
                key={level.id}
                deleteItem={() => handleDeleteItem(level.id)}
                levelsData={levelsData}
                procedureInfoData={procedureInfoData}
                setProcedureInfoData={setProcedureInfoData}
                procedureLevels={procedureLevels}
                isUivSelected={level.uivDropdown.isSelected}
                isLivSelected={level.livDropdown.isSelected}
                uivFirstLevel={uivFirstLevel}
                livFirstLevel={livFirstLevel}
                isFoundDuplicate={isFoundDuplicate}
                setIsUivSelected={(isUivSelected) =>
                    updateUivSelectedState(
                        level.id,
                        'isSelected',
                        isUivSelected
                    )
                }
                setIsLivSelected={(isLivSelected) =>
                    updateLivSelectedState(
                        level.id,
                        'isSelected',
                        isLivSelected
                    )
                }
                errorEachLevelMsg={level.error}
                setErrorEachLevelMsg={(value) =>
                    updateEachErrorState(value, level.id)
                }
                informationaLevellMsg={level.informationalMsg}
                // setInformationalLevelMsg={(value) =>
                //     updateEachErrorState(value, level.id)
                // }
                errorMsg={errorMsg}
                uivStateFromDraft={level?.uivDropdown?.uivState}
                livStateFromDraft={level?.livDropdown?.livState}
                isFromDraft={level?.uivDropdown?.uivState?.isFromDraft}
                uivState={level?.uivDropdown?.uivState}
                livState={level?.livDropdown?.livState}
                currentId={parseInt(level.id)}
                setUivState={(newUivState) =>
                    updateUivLevelState(level.id, 'uivState', newUivState)
                }
                setLivState={(newLivState) =>
                    updateLivLevelState(level.id, 'livState', newLivState)
                }
                setEachUivCount={(value) => updateEachUivCount(level.id, value)}
                setEachLivCount={(value) => updateEachLivCount(level.id, value)}
                updateEachErrorState={updateEachErrorState}
            />
        ));
    };

    const updateUivCount = (id, value) => {
        const updatedUivArray = upsertLevelCodeAtIndex(uivArray, id, value);
        dispatch(setUivLevelArray(updatedUivArray));
    };

    const updateLivCount = (id, value) => {
        const updatedLivArray = upsertLevelCodeAtIndex(livArray, id, value);
        dispatch(setLivLevelArray(updatedLivArray));
    };

    const { t } = useTranslation();
    const [winWidth] = useWindowSize();
    // const isDesktopView = winWidth >= sizes.ipadAir;
    const isMobileView = winWidth < sizes.smalDevice;
    // const anySelectedTrue = procedureInfoData?.levelsData?.some(
    //     (level) => level.isSelected === true
    // );
    // const anySelectedNotFalse = procedureInfoData?.levels?.every(
    //     (level) => level.isSelected !== false
    // );

    return (
        <Box
            my={1}
            bgcolor={'#ffffff'}
            boxShadow={'0px 0px 6px #00000029'}
            borderRadius={5}
            // padding={'16px 22px'}
            width={'99.66%'}
            position={'relative'}
            border={
                // isFirstLevelSelected
                !isErrorFoundInProcedure &&
                !isErrorFoundInFirstLevel &&
                uivDropdownValue?.code !== (0 || undefined) &&
                livDropdownValue?.code !== (0 || undefined)
                    ? '1px solid #12C8F7'
                    : ''
            }
            marginLeft={'1px'}
            marginRight={'1px'}
            paddingBottom={'25px'}
        >
            <LevelTitle>
                <Title
                    paddingTop={'16px'}
                    paddingRight={'11px'}
                    paddingLeft={'22px'}
                    mbpaddingTop={'16px'}
                    mbpaddingRight={'10px'}
                    mbpaddingLeft={'22px'}
                    fontSize={BASE_TEXT_PX}
                >
                    <span>{levelProcdureTitle}</span>
                    <span className="asterisk">*</span>
                </Title>
                <SubTitle
                    fontStyle={FONT_FAMILY_ITALIC}
                    paddingTop={'18px'}
                >
                    Regardless of approach (anterior column/posterior column)
                    select the maximum # of instrumented levels involved
                </SubTitle>
            </LevelTitle>
            <Grid
                container
                style={
                    isMobileView
                        ? { marginLeft: '30px' }
                        : { marginLeft: '130px' }
                }
            >
                <Grid item>
                    <LevelDropdownContainer>
                        <LevelContainer>
                            <Title showAstrisk={true}>{t('UIV')}</Title>
                        </LevelContainer>
                    </LevelDropdownContainer>
                </Grid>
                <Grid item style={{ marginLeft: '98px' }}>
                    <LevelDropdownContainer>
                        <LevelContainer>
                            <Title showAstrisk={true}>{t('LIV')}</Title>
                        </LevelContainer>
                    </LevelDropdownContainer>
                </Grid>
            </Grid>
            <AddProcedureLevel
                id={0}
                levelsData={levelsData}
                procedureInfoData={procedureInfoData}
                uivDropdownValue={uivDropdownValue}
                livDropdownValue={livDropdownValue}
                isFirstLivSelected={isFirstLivSelected}
                isFirstUivSelected={isFirstUivSelected}
                isFoundDuplicate={isFoundDuplicate}
                // setErrorFirstLevelMsg={setErrorFirstLevelMsg((value)=>console.log('value',value))}
                // errorFirstLevelMsg={errorFirstLevelMsg}
                setProcedureInfoData={setProcedureInfoData}
                setUivCount={(value) => updateUivCount(0, value)}
                setLivCount={(value) => updateLivCount(0, value)}
                updateEachErrorState={updateEachErrorState}
            />
            {getAppendProcedureLevel()}
            <StyledText onClick={addProcedureLevelHandler}>+Level</StyledText>
        </Box>
    );
};

export default LevelProcedureCard;
